import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class ParentDataStore extends EventEmitter {
	constructor() {
		super();

		this.parent = {
			data: []
		};

		/*
        Need to register all actions with the AppDispatcher
        */

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchParentData:
					this.parent.data = action.value;
					this.emit("parent_changed");
					break;
				default:
					break;
			}
		});
	}

	/*
    Getter function to return the current state
    */

	getParentData = () => this.parent.data;
	resetParentData = () => {
		this.parent.data = [];
		this.emit("parentData__reset");
	};
}

export default new ParentDataStore();
